module.exports = __webpack_public_path__ + "img/16_7.411cd76e.png";